module.exports = __webpack_public_path__ + "static/media/3.fa13c02d.png";